module.exports = __webpack_public_path__ + "static/media/shabaoliang.cfb3ddce.png";